module.exports = __webpack_public_path__ + "images/emoji/seven.5e8fc13254be0d130c27.png";